import { useQuery } from 'react-query';
import { apiClient } from '../../../services/ApiClient';
import { ApiEndpoints } from '../../../constants/api-constants';
import { Queries, QueryCacheConfig } from '../../../constants/query-constants';
import { type OperationViewModel } from '../../Map/types';
import { type TargetVessel } from '../../../types';
import { buildSearchFilter } from '../utils/search-utils';
import { type SearchResults } from '../types';

export const useOperationsSearchQuery = (
  searchPhrase: string,
  canSearch: boolean,
  operation: string,
  targetVessel: TargetVessel
): SearchResults<OperationViewModel> => {
  const getResults = async (): Promise<OperationViewModel[]> => {
    const searchFilter = buildSearchFilter(searchPhrase, operation, targetVessel?.mmsi);
    return apiClient.get<OperationViewModel[]>(ApiEndpoints.search.getOperations(searchFilter));
  };

  const { data, isLoading } = useQuery({
    ...QueryCacheConfig[Queries.SearchOperation],
    queryKey: [Queries.SearchOperation, searchPhrase, operation, targetVessel?.mmsi],
    queryFn: getResults,
    enabled: canSearch,
  });

  return {
    isLoading,
    data,
  };
};
